import { createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate";

import sessionapi from '@/shared/api/session';
import stayapi from '@/shared/api/stay';
import golfapi from '@/shared/api/golf';
import spaapi from '@/shared/api/spa';
import restaurantapi from '@/shared/api/restaurant';
import giftvoucherapi from '@/shared/api/giftVoucher';


export const store = createStore({
    plugins: [
        createPersistedState({
            key: 'vuex-stay'
        })
    ],
    state: {
        session: null,
        roomConfiguration: null,
        search: null,
        roomAvailability: null,
        roomCalendars: null,
        packagesAvailability: null,
        golfAvailability: null,
        spaConfiguration: null,
        spaAvailability: null,
        spaGardenAvailability: null,

        booking: null
    },
    getters: {
        operaSystemStatus(state) {
            if (state.roomConfiguration != null && state.roomConfiguration.SystemStatuses != null) {


                return state.roomConfiguration.SystemStatuses.find(x => x.System == "Opera");
            }
            return null;
        },
        golfSystemStatus(state) {
            if (state.roomConfiguration != null && state.roomConfiguration.SystemStatuses != null) {


                return state.roomConfiguration.SystemStatuses.find(x => x.System == "Golf");
            }
            return null;
        },
        restaurantSystemStatus(state) {
            if (state.roomConfiguration != null && state.roomConfiguration.SystemStatuses != null) {


                return state.roomConfiguration.SystemStatuses.find(x => x.System == "Restaurant");
            }
            return null;
        },
        spaSystemStatus(state) {
            if (state.roomConfiguration != null && state.roomConfiguration.SystemStatuses != null) {



                return state.roomConfiguration.SystemStatuses.find(x => x.System == "Spa");
            }
            return null;
        },
        stayAvailability(state) {
            return state.roomAvailability;
        },
        booking(state) {
            return state.booking;
        },
        session(state) {
            return state.session;
        },
        roomConfiguration(state) {
            return state.roomConfiguration;
        },
        spaConfiguration(state) {
            return state.spaConfiguration;
        },
        content: (state) => (section) => {

            let configuration = state.roomConfiguration.Content;
            let content = configuration[section];
            return content;

        },
        search(state) {
            return state.search;
        },
        guestQuota: (state) => (leg) => {
            if (state.search != null) {
                return state.search.guestOccupancies[+leg];
            }
            return null;
        },
        numberOfLegs(state) {
            return state.search.guestOccupancies.length;
        },
        giftVoucherMonetaryTotal(state) {

            let result = 0;

            let booking = state.booking;

            if (booking.monetaryVouchers != null) {

                var sum = booking.monetaryVouchers.filter(item => item.content.IsMonetary).reduce(function (a, b) {
                    return a + b.voucher.unitPrice.amount;
                },
                    0);


                result = sum;
            }


            return result;
        },
        roomAvailability: (state) => (leg, roomCode) => {

            if (state.roomAvailability != null && state.roomAvailability.RoomAvailabilities != null) {


                var legAvailability = state.roomAvailability.RoomAvailabilities.find(item => item.Leg == leg);

                if (legAvailability != null && legAvailability.RoomRates != null) {
                    var roomAvailability = legAvailability.RoomRates.find(item => item.Room.Code == roomCode);
                    return roomAvailability;
                }
            }
            return null;
        },
        roomCalendar: (state) => (roomCode) => {
            if (state.roomCalendars != null) {

                let roomCalendar = state.roomCalendars.find(item => item.roomCode == roomCode);
                if (roomCalendar != undefined && roomCalendar.calendarDays != undefined) {
                    return roomCalendar.calendarDays;
                }
            }
        },


        rateAvailability: (state) => (leg) => {

            var legAvailability = state.roomAvailability.RoomAvailabilities.find(item => item.Leg == leg);
            let selectedLeg = state.booking.legs.find(item => item.leg == leg);

            let roomRate = legAvailability.RoomRates.find(item => item.Room.Code == selectedLeg.room.PMSCode);

            return roomRate.Rates;

        },
        packageAvailability(state) {
            return state.packagesAvailability;
        },
        currentLeg: (state) => (leg) => {
            return state.booking.rooms.find(item => item.leg == leg);
        },
        golfAvailability(state) {
            return state.golfAvailability;
        },


        bookingTotal(state) {
            return 100;
        }


    },
    actions: {



        setAccountStatus(context, payload) {
            context.commit("setAccountStatus", payload);
        },
        createSession(context) {
            return new Promise((resolve) => {
                sessionapi.beginStay(t => {
                    context.commit("setSession", t);
                    resolve(t);
                });
            });
        },
        setStep(context, payload) {
            context.commit("setStep", payload);
        },

        setSearch(context, payload) {
            return new Promise((resolve) => {
                context.commit("setSearch", payload);
                resolve();

            });
        },

        clearData(context) {
            return new Promise((resolve) => {
                context.commit('setBooking', null);
                context.commit('setRoomConfiguration', null);
                context.commit('setSearch', null);
                context.commit('setRoomAvailability', null);
                context.commit('clearCalendar');
                context.commit('setPackages', null);

                context.commit('setGolfAvailability', null);
                context.commit('setSpaAvailability', null);
                context.commit('setSpaGardenAvailability', null);


                context.commit('setSpaConfiguration', null);
                resolve();

            });
        },
        clearPartialData(context) {
            return new Promise((resolve) => {
                context.commit('setBooking', null);
                context.commit('setSearch', null);
                context.commit('setRoomAvailability', null);
                context.commit('clearCalendar');
                context.commit('setPackages', null);

                context.commit('setGolfAvailability', null);
                context.commit('setSpaAvailability', null);
                context.commit('setSpaGardenAvailability', null);


                context.commit('setSpaConfiguration', null);
                resolve();

            });
        },
        getConfiguration(context) {
            return new Promise((resolve) => {
                stayapi.getConfiguration(t => {
                    context.commit('setRoomConfiguration', t);
                    resolve(t);
                });
            });
        },
        getSpaConfiguration(context) {
            return new Promise((resolve) => {
                spaapi.getConfiguration(t => {
                    context.commit('setSpaConfiguration', t);
                    resolve(t);
                });
            });
        },
        searchRooms(context, payload) {

            var sessionId = payload.sessionId;
            stayapi.search(sessionId,
                payload,
                t => {

                    context.commit('setRoomAvailability', { HasError: t.HasError, IsAvailable: t.IsAvailable, IsPromoAvailable: t.IsPromoAvailable, RoomAvailabilities: t.RoomAvailabilities });
                    context.commit('setPackages', t.Packages);

                    context.commit('setGiftVouchers', t.GiftVouchers);
                });
        },
        fetchMonthlyCalendar(context, payload) {
            return new Promise((resolve) => {
                stayapi.fetchCalendar(payload.sessionId,
                    payload,
                    t => {
                        resolve(t);
                    });
            });
        },

        fetchCalendar(context, payload) {
            stayapi.fetchCalendar(payload.sessionId,
                payload,
                t => {
                    var result = {
                        roomCode: payload.roomCode,
                        calendarDays: t
                    }
                    context.commit('setCalendar', result);
                });
        },
        fetchPackages(context, payload) {

            return new Promise((resolve) => {
                stayapi.fetchPackages(payload.sessionId,
                    payload,
                    t => {

                        context.commit('setPackages', t);
                        resolve(t);
                    });
            });


        },
        checkGiftVoucherStatus(context, id) {

            return new Promise((resolve, reject) => {
                giftvoucherapi.checkStatus(id, t => {

                    resolve(t);
                }, t => {
                    reject(t);
                });
            });
        },
        getVoucherDetail(context, id) {
            return new Promise((resolve) => {
                giftvoucherapi.getDetail(id, t => {
                    resolve(t);
                });
            });
        },
        attachVoucher(context, payload) {
            return new Promise((resolve) => {
                context.commit('attachVoucher', payload);
                resolve(payload);
            });
        },
        removeVoucher(context, payload) {
            return new Promise((resolve) => {
                context.commit('removeVoucher', payload);
                resolve(payload);
            });
        },
        setGuests(context, payload) {
            return new Promise((resolve) => {
                context.commit('setGuests', payload);
                resolve(payload);
            });
        },


        attachSpaPackage(context, payload) {
            context.commit('setSpaPackage', payload);
        },

        attachDetails(context, payload) {
            return new Promise((resolve) => {
                context.commit('attachDetails', payload);
                resolve(payload);
            });
        },

        createBooking(context, payload) {
            context.commit('createBooking', payload);

        },

        selectRoom(context, payload) {
            context.commit('selectRoom', payload);
        },
        selectRate(context, payload) {
            context.commit('selectRate', payload);
        },

        updateGuests(context, payload) {
            context.commit('updateGuests', payload);
        },

        selectBreakfast(context, payload) {
            context.commit('selectBreakfast', payload);
        },

        selectDinner(context, payload) {
            context.commit('selectDinner', payload);
        },
        selectGolf(context, payload) {
            context.commit('selectGolf', payload);
        },
        selectSpa(context, payload) {
            context.commit('selectSpa', payload);
        },
        selectSpaPool(context, payload) {
            context.commit('selectSpaPool', payload);
        },
        selectPackage(context, payload) {

            return new Promise((resolve) => {

                context.commit('selectPackage', payload);
                resolve(payload);
            });

        },

        selectGolfPackage(context, payload) {

            return new Promise((resolve) => {

                context.commit('selectPackage', payload);
                resolve(payload);
            });

        },

        assignSpaDetails(context, payload) {
            return new Promise((resolve, reject) => {

                spaapi.assignDetails(payload,
                    cb1 => {
                        resolve(cb1);
                    },
                    cb2 => {
                        reject(cb2);
                    });


            });
        },

        selectSpaPackage(context, payload) {

            return new Promise((resolve) => {

                context.commit('setSpaPackage', payload);
                resolve(payload);
            });

        },

        updatePackageQuantity(context, payload) {
            return new Promise((resolve) => {

                context.commit('updatePackageQuantity', payload);
                resolve(payload);
            });

        },

        selectSpaAddOn(context, payload) {
            context.commit("selectPackage", payload);
        },
        selectMudPackage(context, payload) {
            context.commit("selectPackage", payload);
        },


        selectRestaurantPackage(context, payload) {
            return new Promise((resolve) => {

                context.commit('selectPackage', payload);
                resolve(payload);
            });

        },

        removePackage(context, payload) {
            context.commit('removePackage', payload);

        },
        fetchGolfAvailability(context, payload) {

            return new Promise((resolve) => {

                golfapi.getTeeTimes(
                    payload,
                    t => {
                        context.commit('setGolfAvailability', t);
                        resolve(t);
                    });
            });

        },
        fetchGolfPackageAvailability(context, payload) {
            return new Promise((resolve) => {

                golfapi.getTeeTimes(
                    payload,
                    t => {

                        //    context.commit('setGolfAvailability', t);
                        resolve(t);
                    });
            });
        },

        fetchSpaPackageAvailability(context, payload) {
            return new Promise((resolve, reject) => {

                spaapi.getActivitiesList(
                    payload,
                    t => {

                        resolve(t);

                    }, e => {
                        reject(e);
                    });
            });
        },

        fetchSpaPackageTimes(context, payload) {

            return new Promise((resolve, reject) => {

                spaapi.getAvailability(
                    payload,
                    t => {

                        resolve(t);

                    }, e => {
                        reject(e);
                    });
            });
        },

        lockSpaPackage(context, payload) {
            return new Promise((resolve, reject) => {

                spaapi.lock(
                    payload,
                    t => {
                        resolve(t);
                    },
                    t => {
                        reject(t);
                    });
            });
        },


        fetchBreakfastAvailability(context, payload) {
            return new Promise((resolve) => {
                restaurantapi.getAvailability(payload, t => {

                    resolve(t);
                });
            });
        },
        fetchDinnerAvailability(context, payload) {
            return new Promise((resolve) => {
                restaurantapi.getAvailability(payload, t => {

                    resolve(t);
                });
            });
        },


        keepAlive(context) {
            let session = context.getters.session;

            let payload = {
                sessionId: session.Id
            };


            return new Promise((resolve, reject) => {
                stayapi.keepAlive(payload,
                    t => {
                        resolve(t);
                    },
                    t => {
                        reject(t);
                    });
            });
        },

        ignoreBooking(context) {
            let session = context.getters.session;

            let payload = {
                sessionId: session.Id
            };


            return new Promise((resolve, reject) => {
                stayapi.ignoreBooking(payload,
                    t => {
                        resolve(t);
                    },
                    t => {
                        reject(t);
                    });
            });
        },


        sendBooking(context, initiatingLeg) {

            let booking = context.getters.booking;
            let session = context.getters.session;

            var payload = {
                initiatingLeg,
                arrivalDate: booking.arrivalDate,
                numberOfNights: booking.numberOfNights,

                roomStays: booking.legs.filter(x => x.rate != null).map(x => {
                    return {

                        promoCode: x.rate.availableRate.PromotionCode,
                        blockCode: x.rate.availableRate.BlockCode,
                        corporateCode: x.rate.availableRate.CorporateCode,
                        roomCode: x.room.PMSCode,
                        rateCode: x.rate.availableRate.RateCode,
                        leg: x.leg,
                        guestQuota: x.guestQuota

                    }
                })
            };


            return new Promise((resolve, reject) => {
                stayapi.sendBooking(session.Id, payload, t => {
                    context.commit('assignOperaDataToBooking', t);
                    resolve(t);
                }, f => {
                    reject(f);
                });
            });
        },
        stageBooking(context) {

            let booking = context.getters.booking;
            let session = context.getters.session;


            let monetaryVouchers = null;
            if (booking.monetaryVouchers != undefined && booking.monetaryVouchers != null) {
                monetaryVouchers = booking.monetaryVouchers.map(i => { return i.voucher.orderItemId });
            }


            var payload = {
                amendId: booking.amendId,
                account: booking.account,
                leadGuest: {
                    title: booking.leadGuest.title,
                    firstName: booking.leadGuest.firstName,
                    lastName: booking.leadGuest.lastName,
                    emailAddress: booking.leadGuest.emailAddress,
                    telephone: booking.leadGuest.telephone,
                    address: {
                        line1: booking.leadGuest.address.line1,
                        line2: booking.leadGuest.address.line2,
                        city: booking.leadGuest.address.city,
                        country: booking.leadGuest.address.country,
                        postCode: booking.leadGuest.address.postCode,
                    }
                },
                arrivalDate: booking.arrivalDate,
                numberOfNights: booking.numberOfNights,
                roomStays: booking.legs.filter(x => x.rate != null).map(x => {
                    let packages = null;
                  
                    if (x.packages != undefined) {
                        packages = x.packages.map(p => {

                            let restaurantBookings = null;

                            if (p.item.content.Restaurant != undefined && p.item.content.Restaurant != null) {
                                restaurantBookings = [];
                                for (let si in p.selections) {
                                    let selection = p.selections[si];

                                    restaurantBookings.push({
                                        hadAvailability: true,
                                        timeSlot: selection.selection,
                                        restaurant: p.item.content.Restaurant.RestaurantId,
                                    });
                                }


                            }


                            let golfBookings = null;
                            if (p.item.content.IsGolf) {
                                golfBookings = {
                                    rounds: p.selections.map(function (s) {
                                        return {
                                            courseId: s.selection.CourseId,
                                            propertyId: s.selection.PropertyId,
                                            greenFeeItemId: s.selection.GreenFeeId,

                                            date: s.date,
                                            timeRef: s.selection.Reference,
                                            playerCount: s.quantity,
                                            mType: s.selection.MType,
                                            playerFirstName: x.guests[0].firstName,
                                            playerLastName: x.guests[0].lastName,
                                            rentalItems: []
                                        }
                                    })
                                }
                            }

                 
                            let spaBookings = null;
                            let spaSelections = p.selections?.filter(item => item.isSpa);
                            if (spaSelections != null && spaSelections.length) {
                                spaBookings = {
                                    items: spaSelections.map(function (item) {
                                        let selection = item.selection;
                                        let treatment = item.selection.treatment;

                                        let treatmentTime = selection.selection.TreatmentTimes[0];
                                        return {
                                            bookingType: 2,
                                            duration: treatment.SelectedDuration.Duration,
                                            displayName: treatment.DisplayName,
                                            appointmentTypeId: treatmentTime.AppointmentTypeID,
                                            actualPrice: treatmentTime.ActualPrice,
                                            clientIndex: selection.guestIndex,
                                            itemType: treatmentTime.ItemType,
                                            startDateTime: treatmentTime.StartTime,
                                            endDateTime: treatmentTime.EndTime,
                                            roomId: treatmentTime.RoomId,
                                            staffId: treatmentTime.StaffId,
                                            facilityId: treatmentTime.FacilityId
                                        }
                                    })
                                }
                            }

                            else if (p.item.content.IsSpaGarden) {
                                let spgSelections = p.selections[0];
                                
                                spaBookings = {
                                    items: spgSelections.guestIndexes.map(function (item) {
                                        return {
                                            bookingType: 3,
                                            duration: 60,
                                            displayName: spgSelections.addOn.content.DisplayName,
                                            appointmentTypeId: spgSelections.selection.AppointmentTypeID,
                                            actualPrice: spgSelections.selection.ActualPrice,
                                            clientIndex: item,
                                            itemType: 1,
                                            startDateTime: spgSelections.selection.StartDateTime,
                                            endDateTime: spgSelections.selection.EndDateTime,
                                            roomId: spgSelections.selection.RoomID,
                                            staffId: spgSelections.selection.StaffID,
                                            facilityId: spgSelections.selection.FacilityID,
                                            groupAppointmentTypeId: spgSelections.selection.GroupAppointmentTypeID
                                        }




                                    })

                                }
                            }
                            else if (p.item.content.IsMudTreatment) {
                                let smgSelections = p.selections[0];

                                spaBookings = {
                                    items: smgSelections.guestIndexes.map(function (item) {

                                        return {
                                            bookingType: 2,
                                            duration: 60,
                                            displayName: smgSelections.addOn.content.DisplayName,
                                            appointmentTypeId: smgSelections.selection.AppointmentTypeID,
                                            actualPrice: smgSelections.selection.ActualPrice,
                                            clientIndex: item,
                                            itemType: 3,
                                            startDateTime: smgSelections.selection.StartDateTime,
                                            endDateTime: smgSelections.selection.EndDateTime,
                                            roomId: smgSelections.selection.RoomID,
                                            staffId: smgSelections.selection.StaffID,
                                            facilityId: smgSelections.selection.FacilityID
                                        }


                                    })

                                }

                             
                            }

                    
                            return {
                                code: p.item.availability.Code,
                                quantity: p.item.availability.PriceCalculationMode === 0 ? p.quantity : 1,
                                restaurantBookings: restaurantBookings,
                                golfBookings: golfBookings,
                                spaBookings: spaBookings
                            }
                        });
                    }

                    let includedPackages = null;
                    if (x.includedPackages != undefined) {
                        includedPackages = x.includedPackages.map(p => {
                            return {
                                code: p.Item.Code,
                                quantity: p.QuantityRequired
                            }
                        });
                    }


                    let breakfast = null;
                    let dinner = null;


                    if (x.breakfast) {
                        breakfast = x.breakfast.map(b => {

                            return {
                                hadAvailability: b.isAvailable,
                                timeSlot: b.timeslot,
                                restaurant: b.restaurant,

                            }
                        });
                    }

                    if (x.dinner) {
                        dinner = x.dinner.map(b => {
                            return {
                                hadAvailability: b.isAvailable,
                                timeSlot: b.timeslot,
                                restaurant: b.restaurant
                            }
                        });
                    }

                    let roomSpaItems = [];
                    if (x.spaPackages != undefined && x.spaPackages != null) {
                        for (let spi = 0; spi < x.spaPackages.length; spi++) {
                            let spItem = x.spaPackages[spi];
                            var item = {
                                bookingType: spItem.bookingType,
                                duration: spItem.duration.Duration,
                                name: spItem.treatment.DisplayName,
                                appointmentTypeId: spItem.time.TreatmentTimes[0].AppointmentTypeID,
                                actualPrice: spItem.time.TreatmentTimes[0].ActualPrice,
                                clientIndex: spItem.guestIndex,
                                itemType: spItem.time.TreatmentTimes[0].ItemType,
                                startDateTime: spItem.time.TreatmentTimes[0].StartTime,
                                endDateTime: spItem.time.TreatmentTimes[0].EndTime,
                                roomId: spItem.time.TreatmentTimes[0].RoomId,
                                staffId: spItem.time.TreatmentTimes[0].StaffId,
                                facilityId: spItem.time.TreatmentTimes[0].FacilityId
                            };
                            roomSpaItems.push(item);

                        }

                    }

                    return {
                        confirmationNumber: x.confirmationNumber,
                        internalIdentifier: x.internalIdentifier,
                        roomCode: x.room.PMSCode,
                        rateCode: x.rate.availableRate.RateCode,
                        promoCode: x.rate.availableRate.PromotionCode,
                        blockCode: x.rate.availableRate.BlockCode,
                        corporateCode: x.rate.availableRate.CorporateCode,
                        leg: x.leg,
                        guestQuota: x.guestQuota,
                        packages: packages,
                        includedPackages: includedPackages,
                        guests: x.guests.map(g => {
                            return {
                                isLoggedInUser: g.isLoggedInUser,
                                isLeadGuest: g.isLeadGuest,
                                title: g.title,
                                firstName: g.firstName,
                                lastName: g.lastName,
                                age: g.age
                            }
                        }),
                        dietaryComments: x.dietaryRequirements,
                        specialRequirements: x.specialRequirements,
                        dinnerBookingRequests: x.dinnerBookingRequests,
                        dogRequests: x.dogRequirements,
                        breakfastRestaurantBookings: breakfast,
                        dinnerRestaurantBookings: dinner,
                        spaSessionId: x.spaSessionId,
                        isBreakfastRequired: x.rate.rateGroupRate.IncludesBreakfast,
                        isDinnerRequired: x.rate.rateGroupRate.IncludesDinner,
                        isSpaRequired: x.rate.rateGroupRate.ForceIsSpa,
                        isGolfRequired: x.rate.rateGroupRate.IncludesGolf,
                        roomSpaItems: roomSpaItems,
                    }
                }),
                monetaryGiftVouchers: monetaryVouchers,
            };

            return new Promise((resolve) => {
                stayapi.stageBooking(session.Id, payload, t => {



                    //context.commit('setSearch', null);
                    //context.commit('setRoomAvailability', null);
                    //context.commit('clearCalendar');
                    //context.commit('setPackages', null);

                    //context.commit('setGolfAvailability', null);
                    //context.commit('setSpaAvailability', null);
                    //context.commit('setSpaGardenAvailability', null);



                    //  context.commit('confirmBooking', t);
                    resolve(t);
                });
            });
        },

        confirmBooking(context, payload) {
            let session = context.getters.session;



            return new Promise((resolve, reject) => {
                stayapi.completeBooking(
                    session.Id,
                    payload,
                    t => {
                        resolve(t);

                    },
                    e => {
                        reject(e);
                    });
            });
        }


    },
    mutations: {
        setSession(state, payload) {
            state.session = payload;
        },
        setStep(state, payload) {
            state.sep = payload;
        },
        setRoomAvailability(state, payload) {
            state.roomAvailability = payload;
        },
        setBooking(state, payload) {
            state.booking = payload;
        },
        setSearch(state, payload) {
            state.search = payload;
        },
        setRoomConfiguration(state, payload) {
            state.roomConfiguration = payload;
        },
        clearCalendar(state) {
            state.roomCalendars = null;

        },

        createBooking(state, payload) {

            let search = state.search;

            state.booking = {
                legs: [],
                arrivalDate: search.arrivalDate,
                numberOfNights: search.numberOfNights,
                code: search.code,
                booker: {
                    leg: null,
                    guestIndex: null,
                    identifier: null,
                    title: null,
                    firstName: null,
                    lastName: null,
                    profileId: null,
                    emailAddress: null,
                    telephone: null,
                    address: {
                        line1: null,
                        line2: null,
                        city: null,
                        postCode: null
                    }
                },
                monetaryVouchers: payload.monetaryVouchers,
                amendId: payload.amendId
            };


        },

        selectRoom(state, payload) {



            let existingLeg = state.booking.legs.find(item => item.leg == payload.leg);

            if (existingLeg) {
                state.booking.legs.pop(existingLeg);
            }

            var legAvailability = state.roomAvailability.RoomAvailabilities.find(item => item.Leg == payload.leg);

            let guests = [];

            for (let i = 0; i < legAvailability.GuestQuota.Adults; i++) {
                guests.push({ guestCategoryIndex: i, isChild: false, title: '', firstName: '', lastName: '', isLoggedInUser: false });
            }


            for (let i = 0; i < legAvailability.GuestQuota.ChildAges.length; i++) {
                let age = legAvailability.GuestQuota.ChildAges[i];
                guests.push({ guestCategoryIndex: i, isChild: true, age: age, title: '', firstName: '', lastName: '', isLoggedInUser: false });
            }


            state.booking.legs.push({
                leg: payload.leg,
                room: payload.room,
                includedPackages: payload.packages,
                guests,
                guestQuota: legAvailability.GuestQuota,
                dietaryRequirements: null,
                specialRequirements: null,
                dinnerBookingRequests: null
            });

        },

        setGuests(state, payload) {
            let booking = state.booking;
            for (var li in booking.legs) {
                let leg = booking.legs[li];

                var payloadLeg = payload.legs.find(item => item.leg == leg.leg);

                leg.guests = payloadLeg.guests;
            }

        },

        attachVoucher(state, payload) {

            let booking = state.booking;
            if (booking.monetaryVouchers == undefined) {
                booking.monetaryVouchers = [];
            }

            let existingItem =
                booking.monetaryVouchers.find(item => item.voucher.orderItemId == payload.voucher.orderItemId);

            if (existingItem != null) {
                return;
            }



            booking.monetaryVouchers.push(payload);
        },
        removeVoucher(state, payload) {
            let booking = state.booking;
            booking.monetaryVouchers.pop(payload);
        },


        attachDetails(state, payload) {

            let booking = state.booking;
            booking.leadGuest = payload.leadGuest;
            booking.account = payload.account;
            if (payload.selectedGuest != null) {

                booking.legs[+payload.selectedGuest.legIndex].guests[+payload.selectedGuest.guestIndex].isLeadGuest =
                    true;

            } else {

                for (let li in booking.legs) {
                    let leg = booking.legs[li];
                    for (let gi in leg.guests) {
                        let guest = leg.guests[gi];
                        guest.IsLeadGuest = false
                    }
                }
            }

            for (var li in booking.legs) {
                let leg = booking.legs[li];
                var payloadRequests = payload.requests.find(item => item.leg == leg.leg);
                leg.dietaryRequirements = payloadRequests.dietaryRequirements;
                leg.dinnerBookingRequests = payloadRequests.dinnerRequests;
                leg.specialRequirements = payloadRequests.specialRequests;
                leg.dogRequirements = payloadRequests.dogRequests;
            }

        },

        selectRate(state, payload) {

            let leg = state.booking.legs.find(item => item.leg == payload.leg);
            leg.rate = payload.rate;
        },
        setCalendar(state, payload) {

            var roomCode = payload.roomCode;

            if (state.roomCalendars == null) {
                state.roomCalendars = [];
            }

            let roomCalendar = state.roomCalendars.find(item => item.roomCode == payload.roomCode);

            if (roomCalendar == null) {
                roomCalendar = { roomCode, calendarDays: [] }
                state.roomCalendars.push(roomCalendar);
            }

            roomCalendar.calendarDays = payload.calendarDays;
        },

        updateGuests(state, payload) {

            let leg = state.booking.legs.find(item => item.leg == payload.leg);
            leg.guests = payload.guests;
        },



        selectDinner(state, payload) {

            let leg = state.booking.legs.find(item => item.leg == payload.leg);
            leg.dinner = payload.restaurantBookings;

        },
        selectBreakfast(state, payload) {

            let leg = state.booking.legs.find(item => item.leg == payload.leg);
            leg.breakfast = payload.restaurantBookings;
        },
        selectGolf(state, payload) {
            let leg = state.booking.legs.find(item => item.leg == payload.leg);
            leg.golf = payload.selection;
        },
        selectSpa(state, payload) {
            let leg = state.booking.legs.find(item => item.leg == payload.leg);
            leg.spa = payload.selection;
        },
        selectSpaGarden(state, payload) {
            let leg = state.booking.legs.find(item => item.leg == payload.leg);
            leg.spaGarden = payload.selection;
        },

        updatePackageQuantity(state, payload) {

            let leg = state.booking.legs.find(item => item.leg == payload.leg);
            var existingPackage = leg.packages.find(p => p.item.availability.Code == payload.item.availability.Code);

            existingPackage.quantity = payload.quantity;
        },

        selectPackage(state, payload) {
            let leg = state.booking.legs.find(item => item.leg === payload.leg);

            if (leg.packages == undefined || leg.packages == null) {
                leg.packages = [];
            }

            var existingPackage = leg.packages.find(p => p.item.availability.Code === payload.item.availability.Code);
            if (existingPackage != null) {
                let index = leg.packages.indexOf(existingPackage);
                leg.packages.splice(index, 1);
            }

            leg.packages.push(payload);

        },
        removePackage(state, payload) {

            let leg = state.booking.legs.find(item => item.leg === payload.leg);

            let existingPackage = leg.packages.find(p => p.item.availability.Code === payload.code);
            let index = leg.packages.indexOf(existingPackage);
            leg.packages.splice(index, 1);
        },

        setPackages(state, payload) {
            state.packagesAvailability = payload;
        },

        setGiftVouchers(state, payload) {

            state.search.giftVouchers = payload;

        },
        setGolfAvailability(state, payload) {
            state.golfAvailability = payload;
        },




        setSpaAvailability(state, payload) {
            state.dinnerAvailability = payload;
        },
        setSpaGardenAvailability(state, payload) {
            state.dinnerAvailability = payload;
        },
        assignOperaDataToBooking(state, payload) {
            let leg = state.booking.legs.find(item => item.leg == payload.Leg);

            leg.confirmationNumber = payload.ConfirmationNumber;
            leg.internalIdentifier = payload.InternalIdentifier;
        },
        stageBooking(state, payload) {
            state.search = payload;
        },
        setLegSpaSessionId(state, payload) {
            let leg = state.booking.legs.find(item => item.leg == payload.leg);
            leg.spaSessionId = payload.spaSessionId;

        },
        setAccountStatus(state, payload) {
            state.session.accountCreateStatus = payload;
        },
        setSpaConfiguration(state, payload) {
            state.spaConfiguration = payload;
        },
        setSpaPackage(state, payload) {
            let leg = state.booking.legs.find(item => item.leg == payload.leg);

            leg.spaPackages = payload.selections;

        }

    }
});
